import { setRelatedResources } from '../../utils/functions.utils'

export const setResourceMaps = (allAdditionalResources: any) => {
  const resourceProducts = new Map()
  const resourceTopics = new Map()
  const resourceIndustry = new Map()
  const resourceDepartment = new Map()

  // GROUP TOPICS
  for (let i = 0; i < allAdditionalResources.length; i++) {
    if (allAdditionalResources[i].node) {
      let resource = allAdditionalResources[i].node

      const metaInformation = resource.metaInformation || []
      const topics = resource.topics || []
      const allTags = [...metaInformation, ...topics]

      for (let j = 0; j < allTags.length; j++) {
        if (allTags[j]?.__typename) {
          if (allTags[j].__typename === 'ContentfulTopicResourceIndustry') {
            resourceIndustry.has(allTags[j].id)
              ? resourceIndustry.set(allTags[j].id, [
                  ...resourceIndustry.get(allTags[j].id),
                  resource,
                ])
              : resourceIndustry.set(allTags[j].id, [resource])
          } else if (allTags[j].__typename === 'ContentfulTopicResourceDepartment') {
            resourceDepartment.has(allTags[j].id)
              ? resourceDepartment.set(allTags[j].id, [
                  ...resourceDepartment.get(allTags[j].id),
                  resource,
                ])
              : resourceDepartment.set(allTags[j].id, [resource])
          } else if (allTags[j].__typename === 'ContentfulTopicResourceTopic') {
            resourceTopics.has(allTags[j].id)
              ? resourceTopics.set(allTags[j].id, [...resourceTopics.get(allTags[j].id), resource])
              : resourceTopics.set(allTags[j].id, [resource])
          } else if (allTags[j].__typename === 'ContentfulTopicResourceProduct') {
            resourceProducts.has(allTags[j].id)
              ? resourceProducts.set(allTags[j].id, [
                  ...resourceProducts.get(allTags[j].id),
                  resource,
                ])
              : resourceProducts.set(allTags[j].id, [resource])
          }
        }
      }
    }
  }

  return {
    resourceProducts,
    resourceTopics,
    resourceIndustry,
    resourceDepartment,
  }
}
export const getRelatedResourcesForPost = (
  webinarRecordingData: any,
  resourceProducts: any,
  resourceTopics: any,
  resourceIndustry: any,
  resourceDepartment: any
) => {
  if (!webinarRecordingData) return []
  const seen = new Set()
  const referrer = webinarRecordingData.referrer || {}
  const relatedResources: any = []
  const referrerTopics = referrer.topics || []
  const referrerMetaInformation = referrer.metaInformation || []
  const referrerAllTags = [...referrerMetaInformation, ...referrerTopics]

  if (webinarRecordingData.resourceCategory?.title === 'Analyst Report') {
    // resourceProducts
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceProducts.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceProducts.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // resourceTopics
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceTopics.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceTopics.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // check resource industry
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceIndustry.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceIndustry.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // check resource department
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceDepartment.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceDepartment.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }
  } else {
    // check resource industry
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceIndustry.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceIndustry.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // check resource department
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceDepartment.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceDepartment.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // resourceProducts
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceProducts.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceProducts.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }

    // resourceTopics
    for (let i = 0; i < referrerAllTags.length && relatedResources.length < 3; i++) {
      if (resourceTopics.has(referrerAllTags[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedResources,
          relatedEntries: resourceTopics.get(referrerAllTags[i].id),
          excludeId: referrer.id,
          seen,
          featured: false,
          resourceLocale: referrer.entryLocale,
        })
      }
      if (relatedResources.length === 3) break
    }
  }

  return relatedResources
}
